import { Schedule } from '@/features/accounts/types';
import CollapseChevron from './CollapseChevron';
import Applicant from '@/features/accounts/schedule/components/Applicant';
import ApplicationStateLabel from '@/features/accounts/schedule/components/ApplicationStateLabel';

interface Props {
  schedule: Schedule;
  collapsed: boolean;
  onToggle: () => void;
}

export default function ScheduleHeader({ schedule, collapsed, onToggle }: Props) {
  const id = schedule.external_id ?? schedule.id;
  const participants = schedule.participants ?? [];

  if (schedule.bookable) {
    return (
      <div>
        <h3 className="text-base font-semibold text-slate-900">#{id}</h3>
        <Applicant participants={participants} tone="text-slate-500" />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={!collapsed}
      className="rounded text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300"
    >
      <h3 className="flex items-center gap-1.5 text-base font-semibold text-slate-400">
        #{id}
        <CollapseChevron collapsed={collapsed} />
      </h3>
      <Applicant participants={participants} tone="text-slate-400" />
      <ApplicationStateLabel schedule={schedule} />
    </button>
  );
}
